<script>
	import * as Yup from "yup";
	import Forms, { useValidations } from "../ursCommon/Forms.svelte";
	import { maskMemberId } from "./Forms.svelte";
	import { FormGroup, Input } from "@sveltestrap/sveltestrap";

	let { memberId, required, disabled = true, requiredErrorText } = $props();

	const { validateField, validateForm, getErrors, resetErrors, removeError } =
		useValidations();

	let formData = $state({
		memberId: "",
	});

	let errors = $derived(getErrors());
	let memberIdHasErrors = $derived(Object.keys(errors).length ? true : false);

	//const regex = /\(?\b([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})\b/;
	const memberIdRegex = /^[Mm]\d{10}$/;

	const requiredSchema = Yup.object().shape({
		memberId: Yup.string()
			.required(requiredErrorText ? requiredErrorText : "Patient id is required")
			.matches(memberIdRegex, "Invalid patient id"),
	});

	let formSchema = $state(requiredSchema);

	export function clearAllErrors() {
		resetErrors();
	}

	export function getValues() {
		return formData;
	}

	export function setValues(data) {
		formData.memberId = data.memberId;
		resetErrors();
	}

	export function hasErrors() {
		return memberIdHasErrors;
	}

	export function validate() {
		validateField(formSchema, "memberId", formData);
	}

	function handleMemberIdInput(event) {
		const input = event.target;
		formData.memberId = maskMemberId(
			input,
			event.inputType,
			"@9999999999",
			formData.memberId,
		);
		if (formData.memberId === "") formData.memberId = undefined;
		validateField(formSchema, "memberId", formData);
	}
</script>

<main>
  <FormGroup floating spacing="mb-3" label="Patient Id">
	  <Input
		  placeholder="M0000000000-00"
		  type="text"
		  bind:value={formData.memberId}
		  oninput={handleMemberIdInput}
		  invalid={Boolean(errors.memberId)}
		  feedback={errors.memberId}
		  maxlength="14"
		  {disabled}
	  />
  </FormGroup>
</main>